import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'System|Criteria|Rules|Criteria Rules Form|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPSystemCriteriaRulesForm';
export type SPSystemCriteriaRulesFormLocNames =
	| `${LocNameStart}ContentNoRules`
	| `${LocNameStart}ButtonAddRule`
	| `${LocNameStart}ErrorOneRuleRequired`;

export const spSystemCriteriaRulesFormLocs: LocDefs<SPSystemCriteriaRulesFormLocNames> = {
	SPSystemCriteriaRulesFormContentNoRules: {
		defaultValue: 'No rules have been created. Use the add button below to create a rule.',
		description: 'Message shown when there are no rules.',
		displayPath: `${pathStart}No rules`,
		displayType: 'Content',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.Content.NoRules',
		...sharedProperties,
	},
	SPSystemCriteriaRulesFormButtonAddRule: {
		defaultValue: 'Add Rule',
		description: 'Add Rule button',
		displayPath: `${pathStart}Add Rule`,
		displayType: 'Button',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.Button.AddRule',
		...sharedProperties,
	},
	SPSystemCriteriaRulesFormErrorOneRuleRequired: {
		defaultValue: 'At least 1 rule is required',
		description: 'At least 1 rule is required error',
		displayPath: `${pathStart}1 Rule Required`,
		displayType: 'Error',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.FieldError.RuleRequired',
		...sharedProperties,
	},
};

export type SPSystemCriteriaRulesFormLocType = LocMap<SPSystemCriteriaRulesFormLocNames>;
